import React, { memo } from 'react';
import { Link, NavLink } from 'react-router-dom';
import classNames from 'classnames';
import NavbarMenu from './NavbarMenu';
import { PERMISSION } from '../../constants';
import Utils from '../../utils/utils';
import UserAvatar from '../Avatar/UserAvatar';
import menuIcon from '../../assets/images/menu.svg';
import MenuItemIconLabel from './MenuItemIconLabel';
import { SignOutIcon } from '../icons';

import './AppHeaderDesktop.scss';
import config from '../../config';

const ExternalAgencyHeader = ({
	userData,
	rightMenuRef,
	menuOpen,
	menuItems,
	toggleMenu,
	handleNavBarNotOnMobileClick,
	isMobile,
	containerRef,
	setShowMobileMenu,
	showMobileMenu,
	toggleMenuRef,
	onLogOut
}) => {
	const cachedLogoId = window.localStorage.getItem('cachedAgencyBrandLogoId');
	const logoUrl = !cachedLogoId ? null : `url(${config.API_URL}/agencies/branding/${cachedLogoId})`;
	const hasContactsViewPermission = Utils.isAuthorizedExact(PERMISSION.AGENCY.CONTACTS_VIEW, userData.permissions);

	return (
		<header className={classNames({ 'app-header-desktop': !isMobile, 'app-header-mobile': isMobile })}>
			{logoUrl ? (
				<Link to="/" className={classNames('logo', 'agency-logo')} style={{ backgroundImage: logoUrl }} />
			) : (
				<Link to="/" className="logo" />
			)}

			{!isMobile ? (
				<div className="facility-and-menu">
					<div className="right-menu flex-one">
						<NavLink
							to={{ pathname: '/private/agency/shifts' }}
							className="shift-menu-item shift-menu-simple-item"
							onClick={handleNavBarNotOnMobileClick}
							activeClassName="active"
						>
							Schedule
						</NavLink>

						<NavLink
							to={{ pathname: '/private/agency/professionals' }}
							className="shift-menu-item shift-menu-simple-item"
							onClick={handleNavBarNotOnMobileClick}
							activeClassName="active"
						>
							Professionals
						</NavLink>

						{hasContactsViewPermission && (
							<NavLink
								to={{ pathname: '/private/agency/contacts' }}
								className="shift-menu-item shift-menu-simple-item"
								onClick={handleNavBarNotOnMobileClick}
								activeClassName="active"
							>
								My Team
							</NavLink>
						)}

						<NavbarMenu
							userData={userData}
							rightMenuRef={rightMenuRef}
							menuOpen={menuOpen}
							menuItems={menuItems}
							toggleMenu={toggleMenu}
						/>
					</div>
				</div>
			) : (
				<>
					<div className={classNames('facility-and-menu', { 'open slide': showMobileMenu })} ref={containerRef}>
						<div className="top-content">
							<div className="user">
								{(userData.name || userData.email) && (
									<>
										<div className="user-section__avatar">
											<UserAvatar initials={userData.initials} />
										</div>
										<div className="user-data">
											<div className="user-name">{userData.name}</div>
											<div className="user-email">{userData.email}</div>
										</div>
									</>
								)}
							</div>
							<div className="core-menu-item" onClick={onLogOut} role="button" aria-hidden="true" tabIndex={0}>
								<MenuItemIconLabel icon={<SignOutIcon color="#FFF" />} label="Sign Out" />
							</div>
						</div>
						<div className="content-menu">
							<NavLink
								to={{ pathname: '/private/agency/shifts' }}
								className="content-menu-item"
								onClick={handleNavBarNotOnMobileClick}
								activeClassName="active"
							>
								<span className="main-menu-label">Schedule</span>
							</NavLink>

							<NavLink
								to={{ pathname: '/private/agency/professionals' }}
								className="content-menu-item"
								onClick={handleNavBarNotOnMobileClick}
								activeClassName="active"
							>
								<span className="main-menu-label">Professionals</span>
							</NavLink>

							{hasContactsViewPermission && (
								<NavLink
									to={{ pathname: '/private/agency/contacts' }}
									className="content-menu-item"
									onClick={handleNavBarNotOnMobileClick}
									activeClassName="active"
								>
									<span className="main-menu-label">My Team</span>
								</NavLink>
							)}
						</div>
					</div>
					<div
						ref={toggleMenuRef}
						className="menu-hamburger cursor-pointer"
						onClick={() => {
							setShowMobileMenu(!showMobileMenu);
						}}
						aria-hidden
					>
						<img src={menuIcon} alt="" className="header-menu-icon" />
					</div>
				</>
			)}
		</header>
	);
};

export default memo(ExternalAgencyHeader);
